import { useSite } from "@/App";
import { LINKS } from "./data";

// Three global CTAs. Gold "Request a Quote" stays dominant.
export default function CtaButtons({ size = "md", stack = false, className = "" }) {
  const { openQuote, openExpert } = useSite();

  const pad =
    size === "lg" ? "px-8 py-4 text-base" : size === "sm" ? "px-4 py-2 text-sm" : "px-6 py-3 text-sm";

  return (
    <div className={`flex ${stack ? "flex-col" : "flex-wrap items-center"} gap-3 ${className}`}>
      <button
        data-testid="cta-request-quote"
        onClick={openQuote}
        className={`focus-gold ${pad} rounded-full font-bold tracking-wide bg-[#C9A44C] text-[#171B22] shadow-[0_8px_30px_rgba(201,164,76,0.35)] hover:bg-[#D6B15A] hover:shadow-[0_10px_40px_rgba(214,177,90,0.5)] hover:-translate-y-0.5 transition-[background-color,transform,box-shadow] duration-300`}
      >
        Request a Quote
      </button>

      <button
        data-testid="cta-ask-expert"
        onClick={openExpert}
        className={`focus-gold ${pad} rounded-full font-semibold tracking-wide bg-[#005EA8] text-white border border-[#005EA8] hover:bg-[#0a6fbf] hover:-translate-y-0.5 transition-[background-color,transform] duration-300`}
      >
        Ask the Expert
      </button>

      <a
        data-testid="cta-financing"
        href={LINKS.FINANCING_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className={`focus-gold ${pad} rounded-full font-semibold tracking-wide bg-[#C3262E] text-white inline-flex items-center gap-2 hover:bg-[#d83a42] hover:-translate-y-0.5 transition-[background-color,transform] duration-300`}
      >
        <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
        Financing Available
      </a>
    </div>
  );
}
